import { Card, CardContent } from "@/components/ui/card";
import { ScrollArea } from "@/components/ui/scroll-area";
import { GraduationCap, Trophy } from "lucide-react";
import { format } from "date-fns";
import { ar } from "date-fns/locale";

interface Props {
  childExams: any[];
}

export default function ParentExamResults({ childExams }: Props) {
  if (childExams.length === 0) {
    return (
      <Card className="shadow-card">
        <CardContent className="py-12 text-center">
          <GraduationCap className="w-10 h-10 text-muted-foreground/30 mx-auto mb-2" />
          <p className="text-muted-foreground text-sm">لا توجد نتائج امتحانات بعد</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="shadow-card">
      <CardContent className="p-0">
        <ScrollArea className="max-h-[400px]">
          <div className="divide-y">
            {childExams.map((exam) => (
              <div key={exam.id} className="p-4 flex items-center gap-3 hover:bg-muted/30 transition-colors">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center shrink-0 ${
                  (exam.percentage || 0) >= 70 ? "bg-emerald-100 text-emerald-600"
                    : (exam.percentage || 0) >= 50 ? "bg-amber-100 text-amber-600"
                    : "bg-red-100 text-red-600"
                }`}>
                  <Trophy className="w-5 h-5" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="font-medium text-foreground text-sm truncate">{exam.exams?.title || "امتحان"}</p>
                  <p className="text-xs text-muted-foreground">
                    {exam.submitted_at ? format(new Date(exam.submitted_at), "dd MMM yyyy", { locale: ar }) : "قيد التقدم"}
                  </p>
                </div>
                <div className="text-left shrink-0">
                  <div className={`text-lg font-bold ${
                    (exam.percentage || 0) >= 70 ? "text-emerald-600" : (exam.percentage || 0) >= 50 ? "text-amber-600" : "text-red-600"
                  }`}>
                    {exam.percentage != null ? `${Math.round(exam.percentage)}%` : "-"}
                  </div>
                  <div className="text-xs text-muted-foreground">{exam.total_score ?? 0}/{exam.max_score ?? 0}</div>
                </div>
              </div>
            ))}
          </div>
        </ScrollArea>
      </CardContent>
    </Card>
  );
}
